import { render, staticRenderFns } from "./assignmentDetail.vue?vue&type=template&id=c6091f1e"
import script from "../../controllers/assignment/assignment-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/assignment/assignment-detail.js?vue&type=script&lang=js&external"
import style0 from "./assignmentDetail.vue?vue&type=style&index=0&id=c6091f1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports